import React from "react";
import "./SelectedOrganization.css";
import OrganizationUsersList from "./OrganizationUsersList";
import OrganizationSamplesList from "./OrganizationSamplesList";

function SelectedOrganization({ organization }) {
    return (
        <div className="SelectedOrganization">
            <div className="SelectedOrganization_header">
                <h2>{organization.name}</h2>
            </div>
            <div className="SelectedOrganization_content">
                <div className="SelectedOrganization_users_list">
                    <OrganizationUsersList id={organization.id} />
                </div>
                <div className="SelectedOrganization_samples_list">
                    <OrganizationSamplesList id={organization.id} />
                </div>
            </div>
        </div>
    );
}

export default SelectedOrganization;
